import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { siteConfig } from '../constant/siteConfig';
import { useLanguage } from '../i18n/LanguageContext';
import { toRedirectUrl } from '../utils/url';

const CheckoutForm = ({ paymentType, email, currency }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const normalizedEmail = (email || '').trim().toLowerCase();
    const { t } = useLanguage();

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!stripe || !elements) return;

        // Prevent any processing for bank transfer
        if (paymentType === 'bank-transfer') {
            console.log(t('checkout.bankTransferNoAction'));
            return;
        }

        setProcessing(true);

        const targetPathOrUrl = paymentType === 'authorization'
            ? siteConfig.setupSucceededPagePath
            : siteConfig.paymentSucceededPagePath;
        const returnUrl = toRedirectUrl(targetPathOrUrl, window.location.origin);

        let result;
        if (paymentType === 'authorization') {
            result = await stripe.confirmSetup({
                elements,
                confirmParams: {
                    return_url: returnUrl,
                    payment_method_data: {
                        billing_details: { email: normalizedEmail },
                    },
                },
                redirect: 'if_required',
            });
        } else {
            result = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    // return_url: returnUrl,
                    payment_method_data: {
                        billing_details: { email: normalizedEmail },
                    },
                },
                redirect: 'if_required',
            });
            console.log(result);
            if (result?.paymentIntent?.next_action?.type === "display_bank_transfer_instructions"){
               setProcessing(false); 
               return;
            }
        }

        if (result.error) {
            setError(result.error.message);
            setProcessing(false);
        } else {
            console.log('Payment successful:', result);
            window.location.assign(returnUrl);
        }
    };


    const getButtonLabel = () => {
        switch (paymentType) {
            case "authorization":
                return t('checkout.actionButton.authorization');
            case "verification":
                return t('checkout.actionButton.verification');
            case "manual":
                return t('checkout.actionButton.manual');
            case "bank-transfer":
                return t('home.paymentTypes.bankTransfer');
            case "subscription":
                return t('checkout.actionButton.subscription');
            default:
                return t('checkout.actionButton.default');
        }
    };

    return (
       <>
            <form onSubmit={handleSubmit} className="space-y-4">
                <PaymentElement options={{ layout: 'tabs' }} />
                {error && <div className="text-error">{error}</div>}
                <button
                    className="btn w-full hover:opacity-90"
                    style={{
                        backgroundColor: siteConfig.brandColors.primary,
                        color: siteConfig.brandColors.buttonText,
                    }}
                    disabled={!stripe || processing}
                >
                    {processing ? t('common.processing') : `${getButtonLabel()}`}
                </button>

            </form>
            <button onClick={()=>{
                window.location.reload();
            }} className="btn bg-red-500 mt-3 text-white w-full" disabled={!stripe || processing}>
                {t('common.cancel')}
            </button>
       </>
    );
};

export default CheckoutForm;
